<script>
export default {}
</script>

<template>
  <v-img
    :src="require('@assets/images/idoors_logo_white.png')"
    contain
    aspect-ratio="1.5"
    width="283"
    class="ma-auto"
  />
</template>
